<template>
  <div class="bg-white relative">
    <!-- <div class="absolute bottom-0 z-10 right-0 mob-hidden">
      <img src="@/assets/images/bg-des/bgd1.svg" alt="bg-polygon" />
    </div> -->
    <div class="w-full py-32 relative">
      <div class="bottom-44 absolute md:hidden lg:block mob-hidden">
        <img
          src="@/assets/images/caregiver/medc-dots.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute left-0 mob-hidden bg-designreg43">
        <img
          src="@/assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute right-2 mob-hidden bg-designreg44">
        <img
          src="@/assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute top-56 mob-hidden right-12">
        <img
          src="@/assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>

      <div class="absolute top-56 left-0 mob-hidden">
        <img
          src="@/assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="w-full md:flex justify-between container relative">
        <div class="left-0 md:sticky mb-8 bg-white md:w-1/3 w-full">
          <LeftTop />
          <LeftBottom />
        </div>
        <div
          class="lg:w-8/12 w-full md:absolute right-0 md:pr-4 lg:px-4 md:px-0 bg-white"
        >
          <RightTop />
          <!-- <RightBottom /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftTop from "./components/LeftTop.vue";
import LeftBottom from "./components/LeftBottom.vue";
import RightTop from "./components/RightTop";
import RightBottom from "./components/RightBottom";

export default {
  components: {
    LeftTop,
    LeftBottom,
    RightTop,
    RightBottom,
  },
  metaInfo: {
    title: "Complete your profile- Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Help us to know you and your caregiver needs better.It will take you less than a minute to answer these simple questions. Get Started!",
      },
    ],
  },
};
</script>
